<template>
	<div class="sa-list-component">
		<div class="sa-list-component-header">
			<b-row class="sa-label-info" style="margin-left: 0.5rem; margin-right: 0.5rem">
				<b-col lg="3">
					<p>{{ this.$i18n.t("global.lblTotalRecords") }}: {{ rows }}</p>
				</b-col>
				<b-col lg="9">
					<b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" align="right" size="sm"></b-pagination>
				</b-col>
			</b-row>
		</div>
		<div class="sa-list-component-body">
			<div class="b-table-sticky-header">
				<b-table sticky-header ref="table" stacked="lg" striped hover :items="items" :fields="fields" :current-page="1" :per-page="perPage" :key="listKey" sort-icon-left head-variant="light" class="sa-b-table">
					<template v-slot:cell(actions)="row">
						<b-container class="bv-example-row">
							<b-button v-b-tooltip.hover size="sm" variant="outline-primary no-text" title="Modifica Dashboard" @click="onClickEdit(row)" class="mr-1 no-text">
								<b-icon icon="pencil"></b-icon>
							</b-button>
							<b-button size="sm" v-b-tooltip.hover title="Visualizza Dashboard" variant="outline-secondary" @click="onClickView(row)" class="mr-1 no-text">
								<font-awesome-icon icon="eye" />
							</b-button>
						</b-container>
					</template>
				</b-table>
			</div>
		</div>
		<div class="sa-list-component-footer">
			<b-row class="sa-label-info" style="margin-left: 0.5rem; margin-right: 0.5rem">
				<b-col lg="3">
					<p>{{ this.$i18n.t("patients.lblTotalRecords") }}: {{ rows }}</p>
				</b-col>
				<b-col lg="9">
					<b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" align="right" size="sm"></b-pagination>
				</b-col>
			</b-row>
		</div>
	</div>
</template>

<script>
import UtilityMixin from "../../utility/UtilityMixin";
export default {
	mixins: [UtilityMixin],
	data() {
		return {
			rows: 0,
			perPage: 50,
			currentPage: 1,
			pathResource: "/dataanalysiselaborazionebatch",
			filtro: {},
			items: [],
			listKey: 0,
			fields: [
				{
					label: "Nome",
					key: "nome",
					sortable: true,
				},
				{
					label: "Descrizione",
					key: "descrizione",
					sortable: true,
				},
				{
					label: "Stato",
					key: "statoAttuale",
					sortable: true,
				},
				{ class: "sa-table-column-action-double", key: "actions", label: "" },
			],
		};
	},
	mounted() {
		let me = this;
		let sessionStorage = window.sessionStorage;
		if (sessionStorage["filtroDataAnalysisElaborazioniBatchList"]) {
			me.filtro = JSON.parse(sessionStorage["filtroDataAnalysisElaborazioniBatchList"]);
		}
		me.loadData();
	},
	methods: {
		loadData() {
			UtilityMixin.methods.loadDataResources(this.pathResource, {}, this.loadDataSuccess, this.loadDataError);
		},
		loadDataSuccess(response) {
			this.items = response.data.data.list;
			this.rows = response.data.data.recordsNumber;
			this.listKey++;
			this.$emit("afterLoadData", this.items);
		},
		loadDataError(error) {
			console.log(error);
			this.$emit("afterLoadData", this.items);
		},
	},
};
</script>

<style></style>
